import {Card, Divider, Flex, Space, Tag} from "antd";
import {useEffect, useContext} from "react";
import { trainingData } from "../../Constants";
import {ThemeContext} from '../../contexts/ThemeContext';
import oneDrawLogo from "../../assets/img/logos/one_draw_logo.png"
import oneDrawLogoWhite from "../../assets/img/logos/one_draw_logo_white.png"

const TrainingPage = () => {

    const {theme} = useContext(ThemeContext);
    const trainingVideoData = trainingData;

    useEffect(()=>{
        document.title = `OneDraw Training Videos`;
    },[])

    return (
        <div className='app__layout default'>
            <div className='training__content_main_wrapper'>
                <Space
                    className={"training__content_main_header"}
                    >
                        <div className="auth__header--logo" style={{width: "250px", marginBottom: '20px'}}>
                            <img src={theme === 'dark' ? oneDrawLogoWhite : oneDrawLogo} alt="OneDraw"/>
                            <h1 className={"theme-based-text-color"}>Training Videos</h1>
                        </div>
                </Space>
                <Divider/>
                <Flex
                    align={'center'}
                    wrap={"wrap"}
                    gap="middle"
                    className={"training__content_main"}
                >

                    {trainingVideoData.map((video, index) => (
                        <Card
                            key={index}
                            title={video.name}
                            style={{width: "32%", textAlign: "center"}}
                        >
                            <Space>
                                <iframe width="320" height="240" src={video.link} allowFullScreen></iframe>
                            </Space>
                            <Divider/>
                            <Space>
                                <p>{video.description}</p>
                            </Space>
                            <br/>
                            <br/>
                            <Space>
                                <Flex wrap='wrap' gap='middle' justify="center">
                                    {video.tags.map((tag, index) => {
                                        return(<Tag color="blue" key={index}>{tag}</Tag>)
                                    })} 
                                </Flex>
                            </Space>
                        </Card>
                    ))}
                </Flex>
            </div>
        </div>
    );
}

export default TrainingPage;